import React, { useEffect, useState } from 'react';
import aboutUs from '../../Content/Data/AboutUs/aboutUs.json';

function AboutUs(props) {
    const [Images, setImages] = useState(null);

    useEffect(() => {
        if (document.location.pathname.includes("/aboutus")) {
            loadData();
        }
    }, [props.isPathChanged]);

    const loadData = async () => {
        for (let i = 0; i < aboutUs.Images.length; i++) {
            try {
                const image = await import(`../../Content/Images/${aboutUs.Images[i]["ImgName"]}`);
                let images = {
                    ...Images,
                    [aboutUs.Images[i]["ImgKey"]]: image.default
                };
                setImages(images);
            }
            catch (error) {
                console.error("Failed to load image:", error);
            }
        }
    };

    function getListData(item) {
        return item.Content.map((a, i) => {
            let content = " " + a.Description + " ";
            if (a.Links && a.Links.length > 0) {
                a.Links.map(x => {
                    let link;
                    if (x.Type === "text anchor") {
                        link = `<a href=${x.Url} target='_blank'>${x.Text}</a>`;
                    }
                    else if (x.Type === "button anchor") {
                        link = `<a href=${x.Url} target='_blank'><button>${x.Text}</button></a>`;
                    }
                    content = content.replaceAll(x.ReplaceText, link);
                });
            }
            if (item.IsNotList) {
                return (
                    <div key={i}>
                        {
                            a.Title ?
                                <b>
                                    {a.Title}
                                </b> : ""
                        }
                        <span dangerouslySetInnerHTML={{ __html: content }} />
                    </div>
                )
            }
            else {
                return (
                    <li key={i}>
                        {
                            a.Title ?
                                <b>
                                    {a.Title}
                                </b> : <React.Fragment />
                        }
                        <span dangerouslySetInnerHTML={{ __html: content }} />
                    </li>
                )
            }
        });
    }

    return (
        <div className="about-us">
            <div className="about-us-container">
                {
                    aboutUs.Data.map((item, index) => {
                        if (item.Type.toLowerCase() === "image") {
                            return (
                                <div className="about-us-image" key={index}>
                                    {Images && <img src={Images[item.ImgKey]} alt={item.AltText} />}
                                </div>
                            );
                        }
                        else if (item.Type.toLowerCase() === "text header") {
                            return (
                                <div className="about-us-heading" key={index}>
                                    {item.Content}
                                </div>
                            );
                        }
                        else if (item.Type === "text") {
                            let content = item.Content + " ";
                            if (item.Links && item.Links.length > 0) {
                                item.Links.map(x => {
                                    let link;
                                    if (x.Type === "text anchor") {
                                        link = `<a href=${x.Url} target='_blank'>${x.Text}</a>`;
                                    }
                                    else if (x.Type === "button anchor") {
                                        link = `<a href=${x.Url} target='_blank'><button>${x.Text}</button></a>`;
                                    }
                                    content = content.replaceAll(x.ReplaceText, link);
                                });
                            }
                            return (
                                <div key={index} className="about-us-content" dangerouslySetInnerHTML={{ __html: content }} />
                            );
                        }
                        else if (item.Type === "json array") {
                            return (
                                <div key={index} className={item.IsSubTree ? 'about-us-content services-sub-tree' : "about-us-content"}>
                                    {
                                        !item.IsNotList ?
                                            item.ListType && item.ListType === "Ordered" ?
                                                <ol type={item.ListOrderType}>
                                                    {getListData(item)}
                                                </ol>
                                                :
                                                <ul>
                                                    {getListData(item)}
                                                </ul>
                                            :
                                            getListData(item)
                                    }
                                </div>
                            );
                        }
                        else return "";
                    })
                }
            </div>
        </div>
    );
}

export default AboutUs;
